import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "documentType",
    "analyzeBlock",
    "analyzeSelect",
  ]

  connect() {
    this.itemizedTypes = this.element.getAttribute('data-itemized-types').split(',');
  }

  refresh() {
    const selectedType = this.documentTypeTarget.value;
    if (this.itemizedTypes.indexOf(selectedType) === -1) {
      this.analyzeBlockTarget.classList.add("hidden");
      this.analyzeSelectTarget.value = 'false';
    } else {
      this.analyzeBlockTarget.classList.remove("hidden");
      this.analyzeSelectTarget.value = '';
    }

    // Trigger a change event so our form validation will notice the change.
    this.analyzeSelectTarget.dispatchEvent(new Event('change'));
  }
}